import { QRCodeSVG } from "qrcode.react";
import { useNavigate } from "react-router-dom";
import { Stethoscope, Printer, ArrowLeft } from "lucide-react";

export default function InstapharmPoster() {
  const navigate = useNavigate();
  const url = `${window.location.origin}/instapharm`;
  return (
    <div className="min-h-screen bg-white">
      <div className="max-w-lg mx-auto px-8 py-12 text-center print:py-6">
        <div className="no-print mb-6 flex justify-between items-center">
          <button data-testid="poster-back" onClick={() => navigate(-1)} className="inline-flex items-center gap-1 text-sm text-slate-500 hover:text-slate-800"><ArrowLeft className="h-4 w-4" /> Retour</button>
          <button data-testid="print-btn" onClick={() => window.print()} className="inline-flex items-center gap-2 h-11 px-5 rounded-xl bg-[#1E3A8A] text-white text-sm font-medium">
            <Printer className="h-4 w-4" /> Imprimer l'affiche
          </button>
        </div>
        <div className="inline-flex items-center gap-2 mb-8">
          <div className="h-11 w-11 rounded-xl bg-[#1E3A8A] grid place-items-center text-white"><Stethoscope className="h-6 w-6" /></div>
          <span className="font-['Outfit'] font-bold text-2xl text-slate-900">Services d'urgence</span>
        </div>
        <h1 className="font-['Outfit'] text-3xl font-bold text-slate-900 leading-tight mb-3" data-testid="poster-title">
          Besoin d'un médecin aujourd'hui ?
        </h1>
        <p className="text-lg text-slate-600 mb-8">Scannez pour trouver une solution ouverte autour de vous.</p>
        <div className="inline-block rounded-2xl border-4 border-[#1E3A8A] p-5 bg-white">
          <QRCodeSVG value={url} size={260} level="M" fgColor="#1E3A8A" data-testid="poster-qr" />
        </div>
        <p className="text-xs text-slate-400 mt-6 break-all">{url}</p>
        <p className="text-xs text-slate-400 mt-1">Aucune donnée personnelle ou médicale n'est transmise par ce QR code.</p>
      </div>
      <style>{`@media print { .no-print { display: none; } }`}</style>
    </div>
  );
}
